'use client';

import styles from '@/styles/site-breadcrumbs.module.css';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { jsonLdScriptProps } from 'react-schemaorg';
import { BreadcrumbList } from 'schema-dts';
import globalMeta from '../../constants/global-meta';
import { usePathname } from 'next/navigation';
interface BreadCrumbItem {
  name: string;
  link: string;
}

export default function SiteBreadCrumbs(props: { othersLinksBeforeName?: BreadCrumbItem[]; name: string }) {
  const { othersLinksBeforeName: othersLinksBeforeChildren = [] } = props;
  const pathname = usePathname();

  if (!pathname) {
    return null;
  }

  const excludePaths = [`/`, `/vagas`, `/vagas/buscar`, `/vagas/cargo`, `/vagas/emprego`, `/vagas/empresa`];

  const pathnameSplit = pathname.split(`/`);

  const paths = pathnameSplit
    .slice(0, pathnameSplit.length - 1)
    .reduce((paths, currentEndpoint, index, allEndpoints) => {
      const link = `${allEndpoints.slice(0, index).join(`/`)}/${currentEndpoint}`;
      let label = ``;
      if (currentEndpoint === `vagas-az`) {
        label = `Vagas de A a Z`;
      } else {
        label = currentEndpoint;
      }
      paths.push({
        link,
        name: label,
      });
      return paths;
    }, [] as BreadCrumbItem[])
    .filter((path) => !excludePaths.includes(path.link));

  const allPaths: BreadCrumbItem[] = [{ name: `Início`, link: `/` }, ...paths, ...othersLinksBeforeChildren];

  const breadcrumbs = [
    ...allPaths.map((path) => (
      <Link underline="hover" key={`breadcrumbs-${path.name}`} color="inherit" href={path.link}>
        {path.name}
      </Link>
    )),

    <span key="breadcrumb-current-page">{props.name}</span>,
  ];

  return (
    <>
      <script
        {...jsonLdScriptProps<BreadcrumbList>({
          '@context': `https://schema.org`,
          '@type': `BreadcrumbList`,
          itemListElement: [
            ...allPaths.map(
              (path, index) =>
                ({
                  '@type': `ListItem`,
                  position: index + 1,
                  name: index === 0 ? `Home` : path.name,
                  item: index === 0 ? globalMeta.siteUrl : globalMeta.siteUrl + path.link,
                }) as any,
            ),
            {
              '@type': `ListItem`,
              position: allPaths.length,
              name: props.name,
            },
          ],
        })}
      />
      <Stack spacing={2} className={styles.container}>
        <Breadcrumbs separator="›" aria-label="breadcrumb">
          {breadcrumbs}
        </Breadcrumbs>
      </Stack>
    </>
  );
}
